import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchField } from '@/common/components/Fields/SearchField/SearchField';
import { Grid } from '@/common/components/Grid/Grid';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { ROUTES } from '@/common/constants/routes';
import { useGetDiscounts } from '@/common/integrations/menhir/employee/discounts/discounts.hooks';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';
import { usePageViewTracking } from '@/web/hooks/usePageViewTracking';
import { Redirect } from 'expo-router';
import { DiscountsList } from './components/DiscountsList/DiscountsList';

export function DiscountsPage() {
  usePageViewTracking('discounts_page');
  const {
    features: { FF_DISCOUNTS },
  } = useGetFeatures();
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const { discounts } = useGetDiscounts();

  if (!FF_DISCOUNTS) {
    return <Redirect href={ROUTES.NOT_FOUND} />;
  }

  const filteredDiscounts = discounts.filter((discount) =>
    discount.partnerName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <PageLayout headerProps={{ title: t('wallet.discounts.title') }}>
      <Grid columnBasis="basis-[24rem]" gap="section">
        <SearchField
          label={t('dashboard.discounts.search')}
          value={search}
          onChange={setSearch}
        />
      </Grid>
      <DiscountsList discounts={filteredDiscounts} />
    </PageLayout>
  );
}
